import { registerQuery, registerMutation } from 'data-fetching-client';
import { getEcosystemClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import appAuthStack from 'hub-http/stacks/hubapi';
const appUsersClient = promiseClient(createStack(coreMiddlewares.base('app-users/v1/'), appAuthStack));
export const GET_ADMINS = registerQuery({
  fieldName: 'admins',
  args: [],
  fetcher: async () => {
    try {
      const users = await appUsersClient.get(`users`);
      const activeAdmins = users.filter(user => user.roleNames.includes('super-admin')).filter(user => !user.roleNames.includes('deactivated-user'));
      return activeAdmins;
    } catch (error) {
      console.error('Error fetching admins:', error);
      throw error;
    }
  }
});
export const SEND_ADMIN_EMAIL = registerMutation({
  fieldName: 'sendAdminEmail',
  args: ['adminUserId', 'listingId', 'adminInstall', 'permissions'],
  fetcher: async ({
    adminUserId,
    listingId,
    adminInstall = false,
    permissions = []
  }) => {
    const ecosystemClient = getEcosystemClient('app');
    const endpoint = adminInstall ? 'permissions/request-admin-install' : 'permissions/request-from-admin';
    const data = adminInstall ? {
      adminUserId,
      listingId
    } : {
      adminUserId,
      listingId,
      permissions
    };
    try {
      await ecosystemClient.post(endpoint, {
        data
      });
      return {
        success: true
      };
    } catch (error) {
      console.error('Error sending admin email:', error);
      throw error;
    }
  }
});

// Legacy wrapper function for backward compatibility
export const sendAdminEmail = async (adminUserId, listingId, adminInstall = false, permissions = []) => {
  const ecosystemClient = getEcosystemClient('app');
  const endpoint = adminInstall ? 'permissions/request-admin-install' : 'permissions/request-from-admin';
  const data = adminInstall ? {
    adminUserId,
    listingId
  } : {
    adminUserId,
    listingId,
    permissions
  };
  try {
    await ecosystemClient.post(endpoint, {
      data
    });
  } catch (error) {
    console.error('Error sending admin email:', error);
    throw error;
  }
};